import type { AppDictionary } from './pt';
import * as chrome from './en/chrome';
import { auth } from './en/auth';
import { dashboard } from './en/dashboard';
import { people } from './en/people';
import { onboarding } from './en/onboarding';
import { teams } from './en/teams';
import { articles } from './en/articles';
import { settings } from './en/settings';
import { admin } from './en/admin';

/** English dictionary — mirrors `pt.ts` (checked against `AppDictionary`). */
export const en: AppDictionary = {
  common: chrome.common,
  roles: chrome.roles,
  modules: chrome.modules,
  moduleHints: chrome.moduleHints,
  shell: chrome.shell,
  topbar: chrome.topbar,
  nav: chrome.nav,
  notifications: chrome.notifications,
  attendance: chrome.attendance,
  impersonation: chrome.impersonation,
  cmd: chrome.cmd,
  status: chrome.status,
  tabbar: chrome.tabbar,
  shared: chrome.shared,
  bilingual: chrome.bilingual,
  auth,
  dashboard,
  people,
  onboarding,
  teams,
  articles,
  settings,
  admin,
};
